import { ToggleBottomMenuButton } from '~/modules/design-board/component/mobile-menu/ToggleBottomMenuButton';
import type { DetailedPinWithChecked } from '../all-pins/AllPins';

interface TileTopActionButtonsMobileProps {
    pin: DetailedPinWithChecked;
    isArticleTile?: boolean;
}

export const TileTopActionButtonsMobile = ({
    pin,
    isArticleTile = false,
}: TileTopActionButtonsMobileProps) => {
    return (
        <>
            {!isArticleTile && (
                <ToggleBottomMenuButton
                    bottomMenuData={{ type: 'pin' }}
                    currentPinData={pin}
                />
            )}
        </>
    );
};
